import React, { useEffect, useState } from "react";
import { api } from "../../../software/api";
import { toast } from "sonner";
import { X, Magnet } from "lucide-react";

const yellow = "bg-[#ffffcc] border border-[#7f9db9] text-[12px] text-slate-900 outline-none focus:border-[#123a63]";

// Access-style reminder: [date][remind who][x] / [reminder text]. Edits save as you go.
export const ClientReminderCard = ({ r, team, onChanged }) => {
  const [text, setText] = useState(r.text || "");
  const [due, setDue] = useState((r.due_date || "").slice(0, 10));
  useEffect(() => setText(r.text || ""), [r.text]);
  useEffect(() => setDue((r.due_date || "").slice(0, 10)), [r.due_date]);
  const saveDue = () => {
    if (!due || due === (r.due_date || "").slice(0, 10)) return;
    const sun = new Date(due + "T00:00:00").getDay() === 0;
    patch(`due_date=${due}${keepBoard}`, sun ? "No Sundays — moved to the Monday" : "Date updated");
  };
  const patch = async (qs, msg) => {
    try { await api("PATCH", `/reminders/${r.id}?${qs}`); if (msg) toast.success(msg); onChanged(); }
    catch (e) { toast.error(e.message); }
  };
  const keepBoard = r.on_whiteboard ? "&on_board=true" : "";
  const del = async () => {
    if (!window.confirm(`Delete this reminder?\n\n${r.text}`)) return;
    await api("DELETE", `/reminders/${r.id}`); toast.success("Reminder deleted"); onChanged();
  };
  return (
    <div className="py-1 space-y-0.5" data-testid="co-reminder-row">
      <div className="flex items-center gap-0.5">
        <input type="date" value={due} data-testid="co-reminder-date-input"
          onChange={(e) => setDue(e.target.value)} onBlur={saveDue} onKeyDown={(e) => e.key === "Enter" && saveDue()}
          className={`${yellow} w-[104px] h-[22px] shrink-0 px-0.5 py-0`} />
        <select value={r.assigned_to || ""} data-testid="co-reminder-who-select"
          onChange={(e) => patch(`assigned_to=${encodeURIComponent(e.target.value)}${keepBoard}`, "Remind Who updated")}
          className={`${yellow} flex-1 min-w-0 h-[22px] px-0.5 py-0`}>
          <option value="">Everyone</option>
          {team.map((t) => <option key={t}>{t}</option>)}
        </select>
        <button onClick={() => patch(`on_board=${!r.on_whiteboard}`, r.on_whiteboard ? "Taken off the White Board" : "Placed on the White Board")}
          title={r.on_whiteboard ? "On the White Board — click to take off" : "Place on the White Board"} data-testid="co-reminder-board-toggle"
          className={`shrink-0 rounded-sm p-0.5 ${r.on_whiteboard ? "text-amber-600 bg-amber-100" : "text-slate-300 hover:text-amber-600"}`}><Magnet className="h-3.5 w-3.5" /></button>
        <button onClick={del} title="Delete reminder" data-testid="co-reminder-delete"
          className="shrink-0 rounded-sm border border-red-300 bg-white p-0.5 text-red-600 hover:bg-red-50"><X className="h-3.5 w-3.5" strokeWidth={3} /></button>
      </div>
      <textarea rows={2} value={text} onChange={(e) => setText(e.target.value)} data-testid="co-reminder-text-input"
        onBlur={() => text.trim() && text.trim() !== (r.text || "").trim() && patch(`text=${encodeURIComponent(text.trim())}`, "Reminder updated")}
        className={`${yellow} w-full px-1 py-0.5 resize-y leading-snug`} />
    </div>
  );
};
